import React, { useState } from 'react';
import './FAQ.css';

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openItems, setOpenItems] = useState<number[]>([]);

  const faqItems: FAQItem[] = [
    {
      id: 1,
      question: "how much does it cost to request a doodle?",
      answer: "doodle delivery is completely free. we cover all costs including materials, shipping, and delivery."
    },
    {
      id: 2,
      question: "are the doodles any good?",
      answer: "not particularly, but they are real, tangible drawings made for you."
    },
    {
      id: 3,
      question: "how long does it take to receive a doodle?",
      answer: "since this site is fairly new, it shouldn't take too long for me to get requests out."
    },
    {
      id: 4,
      question: "can you draw people?",
      answer: "not super well tbh, but i can certainly try."
    },
    {
      id: 5,
      question: "do you ship internationally?",
      answer: "we primarily ship within the united states. however if you're outside of the united states and really want a doodle feel free to submit a request anyways and i'll see what i can do."
    },
    {
      id: 6,
      question: "what if i don't like my doodle?",
      answer: "no hard feelings here. at least it was free!"
    },
    {
      id: 7,
      question: "can i request multiple doodles?",
      answer: "at this time i ask you only request one doodle. i will update this if things change and i can take on more requests."
    },
    {
      id: 8,
      question: "how old do i have to be to request a doodle?",
      answer: "you must be 18 years or older to request a doodle."
    },
    {
      id: 9,
      question: "what do you do with my information?",
      answer: "your information is only used for sending your doodle. upon submitting, your request gets emailed to me, and then i delete it once the request is processed."
    },
    {
      id: 10,
      question: "can i share my doodle on social media?",
      answer: "please do! we are not currently on any social media platforms, but i will update this if that changes."
    },
  ];

  const toggleItem = (id: number) => {
    setOpenItems((prevOpenItems) =>
      prevOpenItems.includes(id)
        ? prevOpenItems.filter((openId) => openId !== id)
        : [...prevOpenItems, id]
    );
  };

  return (
    <div className="faq-page">
      <div className="faq-header">
        <h1>frequently asked questions</h1>
        <p>everything you need to know about doodle delivery</p>
      </div>

      <div className="faq-container">
        {faqItems.map((item) => (
          <div key={item.id} className={`faq-item ${openItems.includes(item.id) ? 'open' : ''}`}>
            <button
              className={`faq-question ${openItems.includes(item.id) ? 'active' : ''}`}
              onClick={() => toggleItem(item.id)}
            >
              <span>{item.question}</span>
              <span className="faq-icon">{openItems.includes(item.id) ? '−' : '+'}</span>
            </button>
            <div className={`faq-answer ${openItems.includes(item.id) ? 'open' : ''}`}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ; 